import { render, staticRenderFns } from "./Tarjetas.vue?vue&type=template&id=1193d75b&scoped=true"
import script from "./Tarjetas.vue?vue&type=script&lang=js"
export * from "./Tarjetas.vue?vue&type=script&lang=js"
import style0 from "./Tarjetas.vue?vue&type=style&index=0&id=1193d75b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193d75b",
  null
  
)

export default component.exports